import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export async function getOrgPortfolio() {
  const data = await fetcher.get({
    path: '/portfolio/organization',
  });
  return data;
}

export async function createPortfolio(data) {
  const response = await fetcher.post({
    path: '/portfolio',
    body: data,
  });
  return response;
}

export async function updatePortfolio(id, data) {
  const response = await fetcher.put({
    path: `/portfolio/${id}`,
    body: data,
  });
  return response;
}

export async function deletePortfolio(id) {
  const response = await fetcher.delete({
    path: '/portfolio',
    body: { id },
  });
  return response;
}
